<div id="menu-main">
  <div id="menu-head" routerLink="/">
    <h1 title="{{ title }}">
      <div alt="Technomad Audio">
        <div class="technomad">Technomad</div>
        <div class="audio">Audio</div>
      </div>
      <!-- <picture>
        <source srcset="/assets/logo_small.webp" type="image/webp" />
        <source srcset="/assets/logo_small.png" type="image/png" />
        <img src="/assets/logo_small.png" alt="Logo Technomad Audio" />
      </picture> -->
    </h1>
  </div>

  <div id="menu-body">
    <a
      class="menu-item"
      [routerLink]="['/']"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      Accueil
    </a>

    <a
      class="menu-item"
      [routerLink]="['/', 'blog']"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{
        matrixParams: 'exact',
        queryParams: 'ignored',
        paths: 'exact',
        fragment: 'ignored',
      }"
    >
      Actualité
    </a>

    @if (!$computedCategories()) {
      <a class="menu-item">
        Chargement <fa-icon [icon]="['fas', 'cog']" animation="spin"></fa-icon>
      </a>
    }

    @if ($computedCategories()) {
      @for (item of $computedCategories(); track item.id) {
        <a
          class="menu-item"
          [routerLink]="['/', item.slug]"
          onSameUrlNavigation="reload"
          [class.active]="$catalogActive()"
          [class.disabled]="item.disabled"
        >
          {{ item.label }}
        </a>

        @for (subitem of item.children; track subitem.id) {
          <a
            class="menu-subitem"
            [routerLink]="['/', item.slug, subitem.slug]"
            onSameUrlNavigation="reload"
            [class.active]="subitem.active"
            [class.disabled]="subitem.disabled"
          >
            {{ subitem.label }}
          </a>

          <!-- @for (subsubitem of subitem.children; track subsubitem.id) {
            <a
              class="menu-subsubitem"
              [routerLink]="['/', item.slug, subsubitem.slug]"
              [class.active]="subsubitem.active"
              [class.disabled]="subsubitem.disabled"
              >
              {{ subsubitem.label }}
            </a>
          } -->
        }
      }
    }

    <a
      class="menu-item"
      [routerLink]="['/', 'contact']"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{
        matrixParams: 'exact',
        queryParams: 'ignored',
        paths: 'exact',
        fragment: 'ignored',
      }"
    >
      Contact
    </a>
  </div>

  <div id="menu-footer">
    <div>
      <a [routerLink]="['/legal']">Mentions légales</a>
    </div>
    <div>2018 - {{ now.getFullYear() }}</div>
    <div>
      Made by
      <a href="https://it-era.dev" rel="noreferrer noopener" target="_blank"
        >IT-era</a
      >
    </div>
  </div>
</div>
<!-- <div class="border"></div> -->
